// import AuthService from "@/services/doctor/auth.service"
export default {
    namespaced: true,
    state: {
        user: JSON.parse(localStorage.getItem('doctorUser')),
        onesignalPlayerId: null,
        doctortype: JSON.parse(localStorage.getItem('doctortype')),
    },
    getters: {
        getUser(state) {
            return state.user;
        },
        getPlayerId(state) {
            return state.onesignalPlayerId;
        },

        getdoctortype(state) {
            return state.doctortype;
        },
    },
    mutations: {
        setPlayerId(state, playerId) {
            state.onesignalPlayerId = playerId;
        },
        loggedIn(state, user) {
            if (user.token) {
                localStorage.setItem('doctorUser', JSON.stringify(user));
                localStorage.setItem('lastDeviceRegistered', user.mobile);
                state.user = user;
            }
        },
        loggedOut(state) {
            localStorage.removeItem('doctorUser');
            state.user = null;
        },
        DoctorType(state, doctortype) {
            localStorage.setItem('doctortype', JSON.stringify(doctortype));
            state.doctortype = doctortype;
        }

    },
    actions: {

        storeUser({commit}, user) {
            commit('loggedIn', user);
        },

        eraseUser({commit}) {
            commit('loggedOut');
        },

        setOnesignalPlayerId({commit}, playerId) {
            commit('setPlayerId', playerId);
        },

        setdoctortype({commit}, doctortype) {
            commit('DoctorType', doctortype);
        },

        // updateDoctor(edit_form,doctor_id) {
        //
        // },



        // initializeOneSignalPlayerId({commit}) {
        //     window.OneSignal.push(() => {
        //         window.OneSignal.registerForPushNotifications();
        //     });
        //
        //     window.OneSignal.isPushNotificationsEnabled((isEnabled) => {
        //         if (isEnabled) {
        //             // user has subscribed
        //
        //             window.OneSignal.getUserId((playerId) => {
        //                 console.info(playerId);
        //                 commit('setPlayerId', playerId);
        //             });
        //         } else {
        //
        //             window.OneSignal.on('subscriptionChange', (isSubscribed) => {
        //                 window.OneSignal.push(() => {
        //                     window.OneSignal.getUserId((playerId) => {
        //                         commit('setPlayerId', (isSubscribed) ? playerId : null);
        //                     });
        //                 });
        //             });
        //         }
        //     });
        // }
    },
};
